// OrderDetailDialog.jsx — thin router. Each service owns its own order-detail
// dialog (state, handlers, copy); this file only picks which one to mount.
import { normalizeServiceType } from "./utils";
import PickupDeliveryOrderDetailDialog from "./order-detail/PickupDeliveryOrderDetailDialog";
import WashFoldOrderDetailDialog from "./order-detail/WashFoldOrderDetailDialog";
import SneakerCleaningOrderDetailDialog from "./order-detail/SneakerCleaningOrderDetailDialog";

export default function OrderDetailDialog(props) {
  const raw = (props.order?.service_type || "").toLowerCase();
  if (raw === "sneaker_cleaning") return <SneakerCleaningOrderDetailDialog {...props} />;
  if (normalizeServiceType(raw) === "wash_fold") return <WashFoldOrderDetailDialog {...props} />;
  return <PickupDeliveryOrderDetailDialog {...props} />;
}
